var _rect, _rect2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbstractIllustration18(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 438,
    viewBox: "0 0 700 438",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 437.5,
    width: 700,
    height: 437.5,
    transform: "rotate(-180 700 437.5)",
    fill: "url(#paint0_linear_1605_6573)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1605_6573",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 700,
    height: 438
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 700,
    y: 437.5,
    width: 700,
    height: 437.001,
    transform: "rotate(-180 700 437.5)",
    fill: "url(#paint1_linear_1605_6573)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1605_6573)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M865.536 219.607C852.303 202.644 839.139 186.788 823.834 172.172L728.538 280.102C736.81 288.483 745.082 296.863 752.318 306.417C761.967 319.156 770.511 331.962 776.916 346.007C783.321 360.053 789.794 375.205 792.955 390.558C797.22 405.843 799.277 421.263 800.298 437.856C804.383 504.227 781.634 566.675 740.132 612.495C719.416 635.958 694.011 655.264 664.954 669.24C637.001 683.149 606.5 691.661 574.486 693.603C542.472 695.545 511.154 690.783 481.703 680.356C451.148 669.996 423.564 653.904 400.124 633.119C376.684 612.335 357.387 586.858 343.405 557.727C329.492 529.703 320.962 499.131 318.987 467.052C317.898 449.353 319.016 431.52 320.271 415.899C322.629 400.212 326.092 384.457 331.898 370.781C337.637 355.999 345.651 342.189 354.701 327.206C363.819 313.329 375.145 299.318 387.576 285.24L647.571 -9.22152L539.745 -104.83L279.75 189.631C262.141 209.575 245.704 230.558 232.647 252.446C219.589 274.334 207.636 296.155 199.13 319.988C189.521 343.888 183.291 368.692 179.406 395.576C175.452 421.353 173.843 449.209 175.613 477.97C178.813 529.961 191.812 579.136 213.371 623.352C236.101 668.607 266.355 710.074 304.963 743.262C342.467 776.517 386.187 802.734 434.881 819.766C481.3 835.825 531.589 842.768 583.473 839.62C635.358 836.473 684.422 823.504 728.525 801.953C773.664 779.229 815.015 748.963 848.094 710.316C881.241 672.775 907.355 628.999 924.298 580.227C940.273 533.735 947.145 483.354 943.944 431.363C942.378 405.921 938.673 381.718 931.655 357.717C924.638 333.715 916.516 309.781 905.151 287.154C894.685 261.141 881.18 239.754 865.536 219.607Z",
    fill: "#03030D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M217.765 82.3751C229.893 99.4045 244.162 115.194 259.466 129.81L354.763 21.8799C346.491 13.4992 338.218 5.1184 330.982 -4.43552C321.334 -17.1741 312.789 -29.9798 306.384 -44.0254C299.98 -58.0711 293.507 -73.2228 290.346 -88.5755C286.081 -103.861 284.024 -119.281 283.002 -135.874C278.917 -202.245 301.734 -263.587 343.168 -310.513C363.885 -333.976 389.289 -353.282 418.346 -367.258C446.299 -381.167 476.869 -388.573 508.883 -390.515C575.118 -394.533 636.364 -371.601 683.245 -330.032C706.685 -309.247 725.982 -283.77 739.963 -254.639C753.877 -226.615 762.407 -196.043 764.381 -163.964C765.471 -146.265 764.352 -128.432 763.098 -112.811C760.739 -97.1238 757.277 -81.3693 751.47 -67.6932C745.732 -52.911 737.717 -39.101 728.667 -24.1178C719.549 -10.2409 708.223 3.77009 695.793 17.8479L435.798 312.31L543.623 407.918L802.446 112.418C820.055 92.474 836.492 71.4909 849.55 49.6027C862.607 27.7146 874.561 5.89347 884.17 -18.0062C893.779 -41.9058 900.009 -66.7107 903.894 -93.5941C907.848 -119.371 909.458 -147.227 907.687 -175.988C904.487 -227.979 891.488 -277.155 869.93 -321.37C847.199 -366.625 816.946 -408.092 778.337 -441.28C740.833 -474.535 697.114 -500.752 648.419 -517.784C602.001 -533.843 551.711 -540.786 499.827 -537.638C447.942 -534.491 398.879 -521.522 354.775 -499.971C309.636 -477.247 268.285 -446.981 235.206 -408.334C202.06 -370.793 175.945 -327.017 159.002 -278.245C143.027 -231.753 136.156 -181.372 139.356 -129.381C140.922 -103.939 144.628 -79.7363 151.645 -55.735C158.663 -31.7336 166.784 -7.79922 178.149 14.8281C188.547 39.7348 202.12 62.228 217.765 82.3751Z",
    fill: "#03030D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1605_6573",
    x1: 1171.5,
    y1: 326.5,
    x2: 843.711,
    y2: 1054.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29B5E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F60BE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1605_6573",
    x1: 1050,
    y1: 437.5,
    x2: 839.933,
    y2: 1049.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08070D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050A1E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstractIllustration18);
export default __webpack_public_path__ + "static/media/abstract_illustration_18.3c5719e1c1f91af757a031675095c9e3.svg";
export { ForwardRef as ReactComponent };